import { render, staticRenderFns } from "./TextPageUpdate.vue?vue&type=template&id=c53c6e0e&scoped=true&"
import script from "./TextPageUpdate.vue?vue&type=script&lang=js&"
export * from "./TextPageUpdate.vue?vue&type=script&lang=js&"
import style0 from "./TextPageUpdate.vue?vue&type=style&index=0&id=c53c6e0e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c53c6e0e",
  null
  
)

export default component.exports